<div class="flex flex-row relative group pl-4 pr-3 ">
  <!--Whole line-->
  @if (!collapsed) {
    <div (mouseenter)="hovering=true" (mouseleave)="hovering=false"
       [ngClass]="{
       'hover:bg-[rgba(255,255,255,0.35)] hover:cursor-pointer hover:rounded-lg': !disabled,
       'cursor-not-allowed': disabled,
       }"
         [class]="selectedElement == selected ? 'bg-[rgba(217,224,226,0.45)] rounded-lg' : ''"
         class="relative group flex flex-row justify-between items-center pl-2 py-1 select-none w-full">
      <div class="flex flex-row justify-start items-center gap-4 h-8 min-w-0 flex-1">
        <!--  Icon-->
        <div class="flex flex-row w-[32px] justify-center items-center">
          <div [ngClass]="{'rounded-full bg-[rgba(255,255,255,0.35)]': !hovering && selectedElement != selected}"
               class="flex justify-center items-center text-center h-8 w-8">
            <fa-icon #sidebarIconHost [fixedWidth]="true" [icon]="icon" [ngClass]="{
            'text-svg-20': selected == 'dashboard' || selected == 'reports',
            'text-base': selected.includes('files'),
            'icon-size-tasks': selected == 'tasks',
            'text-[16px]': selected == 'hoai' || selected == 'chatBIC',
            'text-[18px]': selected == 'bim-basis-check',
            'text-lg': selected == 'bim-check',
            'text-[20px]': selected == 'quality',
            'icon-size-application': selected == 'application',
            'icon-size-ifc-viewer': selected == 'ifc-viewer',
            }" class="sidebar-icon w-8 h-8 leading-none text-white flex items-center justify-center">
          </fa-icon>
          </div>
        </div>
        @if (opened && !collapsed) {
          <div [ngClass]="{'text-gray-400': disabled}"
               [attr.title]="title"
               class="truncate min-w-0 p-2" style="font-size: 16px;">
            {{ title }}
          </div>
        }
      </div>
      @if (!collapsed && (beta || comingSoon)) {
        <div class="absolute flex flex-row justify-end items-center -top-2 right-1.5 text-[8px]">
          @if (beta && !collapsed) {
            <div class="bg-yellow p-0.5 rounded font-extrabold text-white">BETA</div>
          }
          @if (comingSoon && !collapsed) {
            <div class="bg-green p-0.5 rounded font-extrabold text-white">Bald verfügbar
            </div>
          }
        </div>
      }
    </div>
  }
</div>
